"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlButton = exports.GL_BUTTON_VARIANT = exports.GL_BUTTON_THEME = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _bero = require("bero");
var _componentIcon = require("@adl/component-icon");
var _componentLoader = require("@adl/component-loader");
var _bem = require("./bem");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children", "disabled", "fullWidth", "href", "icon", "isSmall", "theme", "loading", "target", "rel", "variant", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GL_BUTTON_THEME = exports.GL_BUTTON_THEME = {
  light: 'light',
  membership: 'membership'
};
var GL_BUTTON_VARIANT = exports.GL_BUTTON_VARIANT = {
  secondary: 'secondary',
  tertiary: 'tertiary'
};
var getRel = function getRel(target) {
  return target && "noreferrer".concat(target === '_blank' ? ' noopener' : '');
};
var GlButtonCore = /*#__PURE__*/(0, _react.forwardRef)(function GlButton(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    href = _ref.href,
    icon = _ref.icon,
    _ref$isSmall = _ref.isSmall,
    isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
    theme = _ref.theme,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    target = _ref.target,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? getRel(target) : _ref$rel,
    variant = _ref.variant,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var secondary = variant === GL_BUTTON_VARIANT.secondary;
  var tertiary = variant === GL_BUTTON_VARIANT.tertiary;
  var primary = !variant || !secondary && !tertiary;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOnFocus = _useState2[0],
    setIsOnFocus = _useState2[1];
  var showIcon = (icon || primary || secondary || tertiary && !children) && !loading;
  var buttonWrapperClassNames = (0, _bem.bemWrapper)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    'without-text': !children && !primary,
    primary: primary && !theme
  }, "primary-".concat(theme), primary && theme), "secondary", secondary && !theme), "secondary-".concat(theme), secondary && theme), "tertiary", tertiary && !theme && children), "tertiary-".concat(theme), tertiary && theme), "on-focus", isOnFocus));
  var buttonClassNames = (0, _bero.join)((0, _bem.bemCta)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    primary: primary
  }, "primary-".concat(theme), primary && theme), "secondary", secondary && children), "secondary-".concat(theme), secondary && theme), "tertiary", tertiary && children), "secondary-small", secondary && isSmall), "tertiary-".concat(theme), tertiary && theme), "fullWidth", fullWidth), "loading", loading), "disabled", disabled), "icon", !children)), className);
  var getIcon = function getIcon() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'arrow-right-long' : _ref2$name,
      _ref2$standalone = _ref2.standalone,
      standalone = _ref2$standalone === void 0 ? false : _ref2$standalone;
    return name ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentIcon.GlIcon, {
      name: name,
      iconClassName: (0, _bem.bemCta)('icon', {
        standalone: standalone
      }),
      "aria-hidden": "true"
    }) : null;
  };
  var getButtonContent = function getButtonContent() {
    var standalone = children ? false : true;
    var name = icon;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [children && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _bem.bemCta)('content'),
        children: children
      }), showIcon && getIcon({
        name: name,
        standalone: standalone
      }), loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentLoader.GlLoader, {
        className: (0, _bem.bemCta)('loading-spinner', {
          standalone: standalone
        })
      })]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: buttonWrapperClassNames,
    children: href ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", _objectSpread(_objectSpread({
      href: href,
      target: target,
      rel: rel,
      className: buttonClassNames,
      ref: ref
    }, props), {}, {
      children: getButtonContent()
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({
      type: type,
      disabled: disabled,
      className: buttonClassNames,
      ref: ref
    }, props), {}, {
      onFocus: function onFocus() {
        return setIsOnFocus(true);
      },
      onBlur: function onBlur() {
        return setIsOnFocus(false);
      },
      children: getButtonContent()
    }))
  });
});
var GlButton = exports.GlButton = /*#__PURE__*/(0, _react.memo)(GlButtonCore);